<template>
  <div>
    <h1>Work Order Reports</h1>
<div v-if="this.loadingProperties" class="loader">Loading...</div>
    <div class="label-status" v-if="!this.loadingProperties">
      <div class="lable-data">
      <label v-if="alldata.show">Open Work Order: {{ alldata.openIssue }} </label>
      <label v-else>Open Work Order: {{ this.openIssue }} </label>
      <label v-if="alldata.show">Close Work Order: {{ alldata.closeIssue }} </label>
      <label v-else>Close Work Order: {{ this.closeIssue }} </label>
      <label v-if="alldata.show">Total Work Order: {{ alldata.totalIssue }} </label>
      <label v-else>Total Work Order: {{ this.totalIssue }} </label>
      <label v-if="alldata.show">From: {{ alldata.fromDate }} </label>
      <label v-else>From: {{ this.fromDate }} </label>
      <label v-if="alldata.show">To: {{ alldata.toDate }} </label>
      <label v-else>To: {{ this.toDate }} </label>
      </div>
      <div>
      <button v-on:click="reset()" class="reset-filters el-button el-button--danger">Reset Filters</button>
      </div>

    </div>

    <div id="app">
      <div>
        <vue-good-table
          :isLoading.sync="isLoading"
          style="width: 95%; margin: 2% auto"
          :pagination-options="{
            enabled: true,
          }"
          :rows="issues"
          :columns="columns"
          @on-column-filter="onColumnFilter"
          @on-page-change="onColumnFilter"
          ref="issuesTable"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'maintenance'">
              <button
                v-if="props.row.ismaintenance"
                class="myButton el-button el-button--primary"
                @click="toggleRecurringHistory(props.row)"
              >View History</button>
            </span>
            <span v-else-if="props.column.field == 'issuetitle'">
              <a
                style=" text-decoration: none; color: inherit;"
                :href="'/AllIssues#issue-'+props.row.issueid"
              >{{ props.formattedRow[props.column.field] }}</a>
            </span>
          </template>
        </vue-good-table>

        <RecurringIssueHistory
          :currentMaintenanceHistory="this.currentMaintenanceHistory"
          v-if="this.displayRecurringHistory == true"
          v-on:close-recurring-history="toggleRecurringHistory()"
        ></RecurringIssueHistory>
      </div>
    </div>
  </div>
</template>

<script>
import EventService from "@/services/EventService.js";
import { mapState, mapActions } from "vuex";
import moment from "moment";
import RecurringIssueHistory from "@/components/issues/RecurringIssueHistory.vue";
import "flatpickr/dist/flatpickr.css";
import "flatpickr/dist/themes/material_blue.css";
import flatPickr from "flatpickr";
import collect from "collect.js";

export default {
  props: {},
  components: {
    RecurringIssueHistory,
    flatPickr
  },
  data() {
    return {
      Mydate: null,
      displayRecurringHistory: false,
      currentMaintenanceHistory: [],

      isLoading: true,
      search: "",
      filter: "",
      loadingProperties: false,
      columns: [
        {
          label: "Title",
          field: "issuetitle",
          align: "center",
          filterOptions: { enabled: true }
        },
        {
          label: "Asset",
          field: "machinename",
          align: "center",
          filterOptions: {
            enabled: true
          }
        },
        {
          label: "Property",
          field: "propertyname",
          align: "center",
          filterOptions: { enabled: true }
        },
        {
          label: "Status",
          field: "status",
          align: "center",
          filterOptions: {
            enabled: true
          },
          formatFn: this.statusName,
          type: "boolean"
        },

        {
          label: "Due Date",
          field: "duedate",
          formatFn: this.formatDate,
          filterable: true,
          type: "date",
          align: "center",
          dateInputFormat: "MMM DD YYYY hh:mm A",
          dateOutputFormat: "MMM DD YYYY hh:mm A",
          filterOptions: {
            enabled: true,
            placeholder: "Filter Received",
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: "Opened Date",
          field: "opendate",
          formatFn: this.formatDate,
          filterable: true,
          type: "date",
          align: "center",
          dateInputFormat: "MMM DD YYYY hh:mm A",
          dateOutputFormat: "MMM DD YYYY hh:mm A",
          filterOptions: {
            enabled: true,
            placeholder: "Filter Received",
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: "Opened By",
          field: "useropenedname",
          align: "center",
          filterOptions: { enabled: true }
        },
        {
          label: "Assigned By",
          field: "assignedbyusersname",
          align: "center",
          filterOptions: { enabled: true }
        },
        {
          label: "Assigned To",
          field: "userassignedname",
          align: "center",
          filterOptions: { enabled: true }
        },
        {
          label: "Assigned Date",
          field: "assigneddate",
          formatFn: this.formatDate,
          filterable: true,
          type: "date",
          align: "center",
          dateInputFormat: "MMM DD YYYY hh:mm A",
          dateOutputFormat: "MMM DD YYYY hh:mm A",
          filterOptions: {
            enabled: true,
            placeholder: "Filter Received",
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: "Closed Date",
          field: "closedate",
          formatFn: this.formatDate,
          filterable: true,
          type: "date",
          align: "center",
          dateInputFormat: "MMM DD YYYY hh:mm A",
          dateOutputFormat: "MMM DD YYYY hh:mm A",
          filterOptions: {
            enabled: true,
            placeholder: "Filter Received",
            filterFn: this.dateRangeFilter
          }
        },
        {
          label: "Closed By",
          field: "userclosedname",
          align: "center",
          filterOptions: { enabled: true }
        },
        {
          label: "Missed",
          field: "totalmissed",
          align: "center",
          filterOptions: { enabled: true }
        },
        {
          label: "Priority",
          field: "issuepriorityname",
          align: "center",
          filterOptions: {
            styleClass: "class1",
            enabled: true,
            placeholder: "Select Priority"
          }
        },
        {
          label: "Recurring",
          field: "ismaintenance",
          align: "center",
          filterOptions: {
            styleClass: "class1",
            enabled: true,
            placeholder: "Select here"
          },
          formatFn: this.maintenanceName
        },

        {
          label: "Details",
          field: "maintenance",
          align: "center"
        }
      ],
      issues: [],
      alldata: {
        openIssue: 0,
        closeIssue: 0,
        totalIssue: 0,
        fromDate: "",
        toDate: "",
        show: false
      },
      totalIssue: 0,
      openIssue: 0,
      closeIssue: 0,
      fromDate: "",
      toDate: "",
      uniqueAsset: "",
      uniqueProperty: []
    };
  },

  created() {
    this.newTitle("Reports");
    this.loadItems();
    this.loadingProperties = true;
  },
  mounted() {
    let inputs = [
      'input[placeholder="Filter Received"]',
      'input[placeholder="Filter Start Date"]',
      'input[placeholder="Filter Need By Date"]'
    ];
    inputs.forEach(function(input) {
      flatPickr(input, {
        dateFormat: "m-d-Y",
        mode: "range",
        allowInput: true
      });
    });
  },
  methods: {
    ...mapActions(["newTitle"]),

    loadItems() {
      EventService.generateIssueReportForUser().then(response => {
        this.loadingProperties = false;
        this.issues = response.data.reportlist;
        this.totalIssue = response.data.totalissues;
        this.openIssue = response.data.totalopen;
        this.closeIssue = response.data.totalclosed;

        let opendate = [];

        let issues = collect(this.issues);

        let [
          statusOptions,
          openedByOptions,
          assignByOptions,
          assignToOptions,
          closedByOptions,
          assetsOptions,
          propertyOptions,
          priorityOptions,
          recurringOptions
        ] = [
          this.generateStatusOptions(issues),
          this.generateOpenedByOptions(issues),
          this.generateAssignByOptions(issues),
          this.generateAssignToOptions(issues),
          this.generateClosedByOptions(issues),
          this.generateAssetsOptions(issues),
          this.generatePropertyOptions(issues),
          this.generatePriorityOptions(issues),
          this.generateRecurringOptions(issues),
        ];

        this.setOptions("status", statusOptions);
        this.setOptions("useropenedname", openedByOptions);
        this.setOptions("assignedbyusersname", assignByOptions);
        this.setOptions("userassignedname", assignToOptions);
        this.setOptions("userclosedname", closedByOptions);
        this.setOptions('machinename', assetsOptions);
        this.setOptions('propertyname', propertyOptions);
        this.setOptions('issuepriorityname', priorityOptions);
        this.setOptions('ismaintenance', recurringOptions);

        this.issues.forEach(element => {
          if (element.opendate) {
            var date = element.opendate.split("T")[0];
            opendate.push(date);
          }
        });

        this.fromDate = opendate.reduce(function(a, b) {
          return a < b ? a : b;
        });

        this.toDate = opendate.reduce(function(a, b) {
          return a > b ? a : b;
        });
      });
    },

    statusName: function(value) {
      return value == true ? "Open" : "Closed";
    },
    maintenanceName: function(value) {
      return value == true ? "Yes" : "No";
    },
    
    reset() {
      this.$refs["issuesTable"].reset();
      this.alldata.show = false;
    },

    formatDate(value) {
      return !["", null, undefined].includes(value)
        ? moment(value).format("MMM DD YYYY hh:mm A")
        : "-";
    },
    dateRangeFilter(data, filterString) {
      let dateRange = filterString.split("to");
      let startDate = Date.parse(dateRange[0]);
      let endDate = Date.parse(dateRange[1]);
      return (data =
        Date.parse(data) >= startDate && Date.parse(data) <= endDate);
    },

    async onColumnFilter(params) {
      this.alldata = {};
      await this.onColumnFilter;
      let data = this.$refs.issuesTable.filteredRows[0].children;
      if (data.length == 0) {
        this.alldata = {
          openIssue: 0,
          closeIssue: 0,
          totalIssue: 0,
          fromDate: "",
          toDate: "",
          show: true
        };
      } else {
        let closeIssue = 0,
          openIssue = 0;
        let opendate = [];

        data.forEach(element => {
          if (element.status == false) {
            closeIssue++;
          }
          if (element.status == true) {
            openIssue++;
          }
          if (element.opendate) {
            var date = element.opendate.split("T")[0];
            opendate.push(date);
          }
        });
        let totalIssue = data.length;

        let fromDate = opendate.reduce(function(a, b) {
          return a < b ? a : b;
        });

        let toDate = opendate.reduce(function(a, b) {
          return a > b ? a : b;
        });

        this.alldata = {
          openIssue: openIssue,
          closeIssue: closeIssue,
          totalIssue: totalIssue,
          fromDate: fromDate,
          toDate: toDate,
          show: true
        };
      }
    },

    toggleRecurringHistory(row = null) {
      this.loading = true;
      console.log(row);
      if (row && row.maintenancescheduleid) {
        this.getMaintenanceHistory(row.maintenancescheduleid);
      }
      this.displayRecurringHistory = !this.displayRecurringHistory;
    },

    getMaintenanceHistory(maintenanceid) {
      this.currentMaintenanceHistory = [];
      EventService.getRecurringIssueHistory(maintenanceid).then(response => {
        response.data.maintenancehistory.forEach(pastMaintenance => {
          pastMaintenance.scheduleddate = moment
            .parseZone(pastMaintenance.scheduleddate)
            .format("MMM DD YYYY");
          pastMaintenance.completeddate = moment
            .parseZone(pastMaintenance.completeddate)
            .format("MMM DD YYYY");
        });

        this.currentMaintenanceHistory = response.data.maintenancehistory;
      });
    },

    generateOpenedByOptions(issues) {
      let useropenedname = issues.pluck("useropenedname").unique();

      let userOpenedOptions = useropenedname
        .map(item => {
          return {
            value: item,
            text: item
          };
        })
        .values()
        .toArray();

      return userOpenedOptions;
    },
    generateAssignByOptions(issues) {
      let assignedbyusersname = issues.pluck("assignedbyusersname").unique();

      let assignedByOptions = assignedbyusersname
        .map(item => {
          return {
            value: item,
            text: item
          };
        })
        .values()
        .toArray();

      return assignedByOptions;
    },

    generateClosedByOptions(issues) {
      let userclosedname = issues.pluck("userclosedname").unique();

      let closedByOptions = userclosedname
        .map(item => {
          return {
            value: item,
            text: item
          };
        })
        .values()
        .toArray();

      return closedByOptions;
    },

    generateAssignToOptions(issues) {
      let userassignedname = issues.pluck("userassignedname").unique();

      let assignedToOptions = userassignedname
        .map(item => {
          return {
            value: item,
            text: item
          };
        })
        .values()
        .toArray();

      return assignedToOptions;
    },

    generateStatusOptions(issues) {
      let status = issues.pluck("status").unique();

      let issuesOptions = status
        .map(item => {
          return {
            value: item,
            text: item ? "Open" : "Closed"
          };
        })
        .values()
        .toArray();

      return issuesOptions;
    },

    generateAssetsOptions(issues){
      let status = issues.pluck('machinename').unique();

      let issuesOptions = status.map((item)=>{
        return {
          value: item,
          text: item
        }
      }).values().toArray();

      return issuesOptions;
    },

    generatePropertyOptions(issues){

      let status = issues.pluck('propertyname').unique();

      let issuesOptions = status.map((item)=>{
        return {
          value: item,
          text: item
        }
      }).values().toArray();

      return issuesOptions;
    },

    generatePriorityOptions(issues){

      let status = issues.pluck('issuepriorityname').unique();

      let issuesOptions = status.map((item)=>{
        return {
          value: item,
          text: item
        }
      }).values().toArray();

      return issuesOptions;
    },

    generateRecurringOptions(issues){

      let status = issues.pluck('ismaintenance').unique();

      let issuesOptions = status.map((item)=>{
        return {
          value: item,
          text: item? 'Yes' : 'No'
        }
      }).values().toArray();
      
      return issuesOptions;
    },

    /* Find index of column */
    findIndex(field) {
      let foundIndex = this.columns.findIndex(c => {
        return c.field == field;
      });

      return foundIndex;
    },

    /* Set Options to datatable column */
    setOptions(field, options) {
      let index = this.findIndex(field);
      if (index !== -1) {
        console.log(index, options);
        this.$set(
          this.columns[index].filterOptions,
          "filterDropdownItems",
          options
        );
      }
    }
  },
  computed: {
    screenWidth: function() {
      return document.documentElement.clientWidth;
    },
    ...mapState({
      user: state => state.user.user
    })
  }
};
</script>

<style scoped>
h1 {
  margin-top: 80px;
  text-align: center;
}
.date-filter {
  text-align: center;
}
.a-link-style {
  text-decoration: underline;
  color: #193837;
  cursor: pointer;
}
.a-link-style:hover {
  background-color: unset;
  color: unset;
}
.property-dropdown {
  text-align: right;
  margin-right: 3%;
}
.reset-filters {
  
}
.label-status {
  text-align: left;
  margin: 0 2.5%;
    display: flex;
    align-items: baseline;
}
.label-status label {
  padding: 10px 20px;
    background: #2e746e;
    border-radius: 20px;
    margin: 0px 10px;
    color: #ffffff;
    font-weight: 500;
    display: inline-block;
}
.label-status .lable-data{
width: 100%;
}
</style>